
import Spinner from "../../../components/common/Spinner/Spinner";

import {
  Grid,
  Typography,
  Table,
  TableHead,
  TableBody,
  TableRow,
  TableCell,
  Button,
  Stack,
  Pagination,
} from "@mui/material";

import classNames from "classnames";
import { toUpper } from "lodash"
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import styles from "./List.module.scss";
import { AppState } from '@configs/store/rootReducer';
import { openToast } from '@redux/toast/actions';
import Toast from "@components/common/Toast/toast";
import { Link } from "react-router-dom";
import helper from "@utils/helper";
import { fetchConfirmRequest, fetchOrderRequest } from "@redux/User/action";
import ModalConfirm from "@components/paymentUserDetails/modal-confirm";
import InvoiceDraw from "@components/common/invoiceDraw";
import TransactionToolbar from "@components/common/toolbar order";
import useDebounce from "@components/common/Debounce/useDebounce";

const Orders = () => {
  const dispatch = useDispatch();
  const [selectedArray, setSelectedArray] = useState<any>([]);
  const [selectedItem, setSelectedItem] = React.useState<any>();
  const [list, setList] = useState<any>({});
  const { orderResult, totalPageOrder } = useSelector((state: AppState) => state.toUserManager)
  const [message , setMessage] = useState<string>("")
  // const message = useSelector((state: AppState) => state.toTranslate.message);
  const [draw, setDraw] = useState<any>({
    open: false,
  });
  const toggleDrawer = (open: boolean, { ...rest }) => {
    setDraw({ open: open, ...rest });
  };
  const { loading } = useSelector((state: any) => ({
    loading: state?.toUserManager.loading,
  }));
  const [isLoading, setLoading] = useState<any>(null)
  useEffect(()=>{
    setLoading(loading)
  },[loading])
  //========================= new code ===========================//
  const columnTitle = [
    { name: 'STT' },
    { name: 'Code' },
    { name: 'Email' },
    { name: 'Phương thức' },
    { name: 'Thời gian' },
    { name: 'Số tiền' },
    { name: 'Trạng thái' }
  ];
  const STATUS = {
    SUCCESS: 'success',
    FAILURE: 'failure',
    PENDING: 'pending'
  }
  const toast = useSelector((state: AppState) => state.toOpen);
  const [page, setPage] = useState<number>(1);
  const [totalPage, setTotalPage] = useState(0)
  const [openModal, setOpenModal] = React.useState(false);
  const [inputValue, setInputValue] = useState<any>("");
  const [dateFilter, setDateFilter] = useState<any>();
  const [statusFilter, setStatusFilter] = useState<any>("");
  const [keyFilter, setKeyFilter] = useState<string>("id")
  function ControlledPagination() {
    const handleChange = (event: React.ChangeEvent<unknown>, value: number) => {
      setPage(value);
    };

    return (
      <Pagination
        count={totalPage}
        page={page}
        onChange={handleChange}
        variant="outlined"
        shape="rounded"
      />
    );
  }
  const delayInput = useDebounce(inputValue, 1500)

  useEffect(() => {
    if(keyFilter ==='id'){
      dispatch(fetchOrderRequest({
        params: {
          page: page,
          id: '',
          orderId: delayInput,
          createdAt: dateFilter,
          status: statusFilter,
        }
      }));
    }
    else{
      dispatch(fetchOrderRequest({
        params: {
          page: page,
          id: '',
          email: delayInput,
          createdAt: dateFilter,
          status: statusFilter,
        }
      }));
    }
    
  }, [page, delayInput, dateFilter, statusFilter, keyFilter])
  useEffect(()=>{

  },[toast, message])
  useEffect(() => {
    // setLang(language)
    setList(orderResult)
    setTotalPage(totalPageOrder)
    if ( message === "OK") {
      setMessage("")
      dispatch(openToast({
        severity: "success",
        text: "Update Successful!",
        open: true
      }))
    }
    if (message === "Create success") {
      dispatch(openToast({
        severity: "success",
        text: "Create New Language success!",
        open: true
      }))
    }
    if (message === "Language is exit, try again") {
      dispatch(openToast({
        severity: "error",
        text: "Language is exited, try again!",
        open: true
      }))
    }
  }, [orderResult, message])

  function getTime(createdAt: string) {
    const d = new Date(createdAt);
    return (
      <div style={{ width: "100%" }}>
        {`${d.toLocaleTimeString("vi", {
          hour: "2-digit",
          minute: "2-digit",
        })} - ${d.toLocaleDateString("vi", {
          day: "2-digit",
          month: "2-digit",
          year: "2-digit",
        })}`}
      </div>
    );
  }
  const handleCancel = async() => {
    await dispatch(fetchConfirmRequest({params:selectedItem, page: page}));
    await setOpenModal(false);
    await setMessage("OK")
    await dispatch(fetchOrderRequest({
      params: {
        page: page,
        id: '',
        orderId: delayInput,
        createdAt: dateFilter,
        status: statusFilter
      }
    }));
  }
  const handleApprove = async() => {
    await dispatch(fetchConfirmRequest({params:selectedItem}));
    await setOpenModal(false);
    await setMessage("OK")
    await dispatch(fetchOrderRequest({
      params: {
        page: page,
        id: '',
        orderId: delayInput,
        createdAt: dateFilter,
        status: statusFilter,
      }
    }));
  }
  const closeModal = () => {
    setOpenModal(false)
    setSelectedItem(null)
  }
  const handleConfirmBank = (customerDetail: any, amount: any, id: any, approve: boolean) => {
    setSelectedItem({
      approve: approve,
      customerDetail,
      amount,
      id,
    });
    setOpenModal(true);
  }
  const handleClickDraw = (data: any) => {
    setDraw({ open: true, ...data })
  }
  useEffect(()=>{
    console.log(keyFilter)
  },[statusFilter,keyFilter])
  return (
    <React.Fragment>
      <Toast/>
      <Grid className={styles.ContentWrapper}>
        <Grid container className={styles.MenuNav} alignItems={"flex-end"}>
          {/* <Link to="/admin/user-management" className={styles.MenuItemUnActive}>
            User
          </Link> */}
          <Link to="/admin/order-management"
            className={styles.MenuItemActive}
          >
            Orders
          </Link>
        </Grid>
        <Grid>
          <TransactionToolbar 
            inputValue={inputValue}
            setInputValue={setInputValue}
            dateFilter={dateFilter} 
            setDateFilter={setDateFilter}
            statusFilter={statusFilter}
            setStatusFilter={setStatusFilter}
            keyFilter={keyFilter}
            setKeyFilter={setKeyFilter}
            />
        </Grid>
        <Grid container direction={"column"} className={styles?.Wrapper}>
          {list && Object.keys(list).length > 0 ? (
            <>
              <Table>
                <TableHead sx={{ backgroundColor: '#F6F6F7' }}>
                  <TableRow>
                    {columnTitle.map((value: any, index: any) => {
                      return (
                        <TableCell align="center" key={index}>
                          <Typography className={styles.TableCellTitle} sx={{ fontWeight: '600' }}>
                            {value.name}
                          </Typography>
                        </TableCell>
                      )
                    }
                    )}
                    <TableCell />
                  </TableRow>
                </TableHead>
                <TableBody>
                  {list?.map((element: any, index: any) => {

                    return (
                      <TableRow
                        key={index}
                        className={classNames(
                          styles.PaperItem,
                          styles.OrderItem,
                          selectedArray.includes(element.default) && styles.PaperActive
                        )}
                        onClick={() => handleClickDraw(element)}
                      >
                        <TableCell align="center">{(page - 1) * 10 + index + 1}</TableCell>
                        <TableCell align="center" style={{ fontWeight: "bold" }}>#{element.id}</TableCell>
                        <TableCell align="center" style={{ color: "#808080" }}>{element?.customerDetail?.email}</TableCell>
                        <TableCell align="center" style={{ color: "#808080" }}>{element?.paymentTypeDetail?.title}</TableCell>
                        <TableCell align="center">{getTime(element?.createdAt)}</TableCell>
                        <TableCell align="center">{helper.formatCash.format(element.amount)} </TableCell>
                        <TableCell align="center">
                          <Grid
                            container
                            justifyContent="center"
                            alignItems="center"
                            spacing={0}
                          >
                            {element.status === STATUS.PENDING ? (
                              <Grid container sx={{ width: "281px !important" }}>
                                <Grid item xs={6}>
                                  <Button
                                    variant="contained"
                                    style={{ background: "#E0E0E0", color: "black" }}
                                    className={
                                      styles.statusBtn
                                    }
                                    onClick={(e) => {
                                      e.stopPropagation();
                                      handleConfirmBank(
                                        element?.customerDetail,
                                        element.amount,
                                        element.id, false)
                                    }
                                    }
                                  >
                                    Từ chối
                                  </Button>
                                </Grid>
                                <Grid item xs={6}>
                                  <Button
                                    variant="contained"
                                    style={{ background: "#40B60A" }}
                                    className={
                                      styles.statusBtn
                                    }
                                    onClick={(e) => {
                                      e.stopPropagation();
                                      handleConfirmBank(
                                        element?.customerDetail,
                                        element.amount,
                                        element.id,
                                        true)
                                    }
                                    }
                                  >
                                    Xác nhận
                                  </Button>
                                </Grid>
                              </Grid>
                            ) : (
                              <div className={styles.boxStatus}>
                                {element.status === STATUS.FAILURE ? (
                                  <Button
                                    className={
                                      styles.failureBtn
                                    }
                                    color="error"
                                  >
                                    Đã từ chối
                                  </Button>
                                ) : (
                                  <Button
                                    className={styles.statusBtnDisable}
                                    style={{ color: "#40B60A" }}
                                    variant="outlined"
                                  >
                                    Đã xác nhận
                                  </Button>
                                )}
                              </div>
                            )}
                          </Grid>
                        </TableCell>
                      </TableRow>
                    );
                  })}
                </TableBody>
              </Table>
              <Grid container display="flex" justifyContent="center" mt={5}>
                <Stack spacing={2}>
                  {/* <Pagination count={totalPage} defaultPage={page} onChange={(e)=>{console.log(e)}} variant="outlined" shape="rounded"/> */}
                  <ControlledPagination />
                </Stack>
              </Grid>
            </>
          ) : (
            <div className={styles.DataEmpty}>Không có dữ liệu</div>
          )}
          {isLoading && <Spinner />}

        </Grid>
      </Grid>

      <Toast />
      <ModalConfirm
        open={!!openModal}
        selectedItem={selectedItem}
        handleCancel={handleCancel}
        handleApprove={handleApprove}
        closeModal={closeModal}
      />
      <InvoiceDraw
        open={draw?.open}
        onClose={() => toggleDrawer(false, {})}
        handleClickBtn={handleConfirmBank}
        amount={draw?.amount}
        id={draw?.id}
        time={draw?.createdAt}
        status={draw?.status}
        invoiceDetails={draw?.invoiceDetails}
        customerDetail={draw?.customerDetail}
        paymentTypeDetail={draw?.paymentTypeDetail}
        cancelledBy={draw?.cancelledBy}
        approvedByDetail={draw?.approvedByDetail}
        cancelledAt={draw?.cancelledAt}
        approvedAt={draw?.approvedAt}
        cancelStatus={draw?.cancelStatus}
      />
    </React.Fragment>
  );
};

export default Orders;
